import { useCallback } from 'react';
import { useSession } from '@sdk/session/SessionContext';

import { useAddReaction } from '@web/conversations/hooks/useAddReaction';
import { useConversationActions } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { Emoji } from '@web/conversations/types/Reactions';

type Props = {
  conversationId: ID;
  emoji: Emoji;
  messageId: ID;
};

export const useAddReactionAction = () => {
  const { currentUser } = useSession();
  const { addReaction } = useConversationActions();
  const mutation = useAddReaction();
  const { mutateAsync } = mutation;

  const action = useCallback(
    async (payload: Props) => {
      addReaction({
        messageId: payload.messageId,
        reaction: payload.emoji,
        userId: currentUser.id,
      });

      await mutateAsync({
        conversationId: payload.conversationId,
        emoji: payload.emoji,
        messageId: payload.messageId,
      });
    },
    [currentUser, mutateAsync, addReaction]
  );

  return { action, mutation };
};
